import { get } from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Header from '../../components/Header';
import { clearStore } from '../../store/signup/signupAction';
import { INFINCE_URL } from '../../utilities/constants';

const Completion = ({
    clearStore,
    needMailServer,
    needDomain,
    infinceUrl,
    trialFormData,
    basicData,
}) => {
    const history = useHistory();
    useEffect(() => {
        return () => {
            clearStore();
            window.location.href = `https://${infinceUrl}`;
        };
    }, [clearStore, history, infinceUrl]);

    useEffect(() => {
        if (!basicData && !trialFormData) {
            window.location.href = `https://${infinceUrl}`;
        }
    }, [basicData, trialFormData, infinceUrl]);

    window.dataLayer.push({
        event: 'pageview',
        page: {
            url: document.location.pathname,
            title: ''
        }
    });

    /**
     * Navigate to infince
     */
    const goToInfince = () => {
        window.location = `https://${infinceUrl}`;
    };
    return (
        <>
            <div className="container">
                <Header />
                <div className="type1-container complete-signup">
                    <h1>Thank you for registering with InfinCE</h1>

                    {needMailServer && needDomain ? (
                        <p>
                            An account activation link will be sent to your
                            registered email as soon as our <br /> administrator
                            approves your request.
                        </p>
                    ) : (
                        <>
                            {needMailServer ? (
                                <>
                                    <p>
                                        To enable setting up your Email Server,
                                        you would need to complete few
                                        verifications on your DNS Manager. Click
                                        the button below & login with the
                                        credentials set while registering.
                                    </p>
                                    <div class="centerd-btn-block completion">
                                        <button
                                            type="button"
                                            className="btn-primary"
                                            onClick={() => goToInfince()}
                                        >
                                            Let's start setting up
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <p>
                                    An account activation link will be sent to
                                    your registered email as soon as our <br />{' '}
                                    administrator approves your request.
                                </p>
                            )}
                        </>
                    )}
                </div>
            </div>
            {needMailServer && !needDomain ? (
                <>
                    <div className="footer-finish">
                        We have also sent you an email with the access link if
                        you would like to continue this later.
                        <p>
                            Chat with our Support team if you would like us to
                            walk you through the process or contact us at{' '}
                            <a
                                href="mailto:support@infince.com"
                                className="secondary"
                            >
                                support@infince.com
                            </a>{' '}
                            for any assistance.
                        </p>
                    </div>
                </>
            ) : (
                <>
                    <div className="footer-finish">
                        Please feel free to contact{' '}
                        <a
                            href="mailto:support@infince.com"
                            className="secondary"
                        >
                            support@infince.com
                        </a>{' '}
                        for further assistance.
                    </div>
                </>
            )}
        </>
    );
};

const mapDispatchToProps = {
    clearStore,
};
const mapStateToProps = (store, props) => ({
    trialFormData: get(store, 'signupReducer.trialFormData', null),
    basicData: get(store, 'signupReducer.basicData', null),
    needMailServer: get(
        store,
        'signupReducer.needMailServer',
        get(store, 'signupReducer.trialFormData', null) ? false : true
    ),
    needDomain: get(store, 'signupReducer.needDomain'),
    infinceUrl: get(store, 'signupReducer.infinceUrl', INFINCE_URL),
});

export default connect(mapStateToProps, mapDispatchToProps)(Completion);
